import React from "react";
import './AppLanding.css';
import Header from './Header';
import Hero from './Hero';
import ServicioDelivery from './ServicioDelivery';
import ServicioSuscripcion from './ServicioSuscripcion';
import ServicioFreelance from './ServicioFreelance';
import ComoFunciona from './ComoFunciona';
import Footer from './Footer';



const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: 'easeOut' } }
};


  function LandingPage() {
    return (
        <div className="landing-root">
        <Header />
        <Hero />
        <ServicioDelivery />
        <ServicioSuscripcion />
        <ServicioFreelance />
        <ComoFunciona />
        <Footer />
      </div>
    );
  }

export default LandingPage;
